import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#0077B5' },
    secondary: { main: '#F5A623' },
    success: { main: '#1D9E75' },
    warning: { main: '#F5A623' },
    error: { main: '#D85A30' },
    background: { default: '#FAFAF8', paper: '#FFFFFF' },
  },
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: { fontSize: '2rem', fontWeight: 500 },
    h2: { fontSize: '1.5rem', fontWeight: 500 },
    h3: { fontSize: '1.25rem', fontWeight: 500 },
    body1: { fontSize: '0.9375rem' },
    body2: { fontSize: '0.8125rem' },
    caption: { fontSize: '0.6875rem' },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', minHeight: 48 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { border: '0.5px solid rgba(0,0,0,0.1)', boxShadow: 'none' },
      },
    },
  },
});

export default theme;
